export default __webpack_public_path__ + "static/media/image-not-found.cc2245f1.png";